module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("体验学生")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 120,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.lessonStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "lessonStatus", _vm._n($$v))
      },
      expression: "queryParam.lessonStatus"
    }
  }, _vm._l((_vm.userLessonStatusList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分配课程顾问："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isAdviser),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isAdviser", _vm._n($$v))
      },
      expression: "queryParam.isAdviser"
    }
  }, _vm._l((_vm.isAdviserList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问昵称："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "studyAdviserName"
    },
    model: {
      value: (_vm.queryParam.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserName", $$v)
      },
      expression: "queryParam.adviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生",
      "label-width": 60
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "ID/手机号/姓名",
      "name": "searchKeyword"
    },
    model: {
      value: (_vm.queryParam.searchKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchKeyword", $$v)
      },
      expression: "queryParam.searchKeyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道："
    }
  }, [_c('channel-select', {
    model: {
      value: (_vm.queryParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regType", $$v)
      },
      expression: "queryParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道来源：",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchChannel", $$v)
      },
      expression: "queryParam.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 9
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "创建时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between",
      "gutter": 12
    }
  }, [_c('Col'), _vm._v(" "), _c('Col', [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.onInsertUser
    }
  }, [_vm._v("添加学生")])], 1), _vm._v(" "), _c('Col', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("分配课程顾问")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/user/experience/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('AssignAdviserModal', {
    attrs: {
      "successCallback": _vm.search,
      "userList": _vm.selectionUser,
      "restrictToSelf": true
    },
    model: {
      value: (_vm.showAssignAdviserModal),
      callback: function($$v) {
        _vm.showAssignAdviserModal = $$v
      },
      expression: "showAssignAdviserModal"
    }
  }), _vm._v(" "), _c('UserTestNetworkModal', {
    attrs: {
      "user": _vm.testNetworkParam
    },
    model: {
      value: (_vm.showTestNetworkModal),
      callback: function($$v) {
        _vm.showTestNetworkModal = $$v
      },
      expression: "showTestNetworkModal"
    }
  }), _vm._v(" "), _c('InsertUserModal', {
    attrs: {
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showInsertUserModal),
      callback: function($$v) {
        _vm.showInsertUserModal = $$v
      },
      expression: "showInsertUserModal"
    }
  }), _vm._v(" "), _c('UserTrialLessonModal', {
    attrs: {
      "user": _vm.trialaLessonUser
    },
    model: {
      value: (_vm.showUserTrialLessonModal),
      callback: function($$v) {
        _vm.showUserTrialLessonModal = $$v
      },
      expression: "showUserTrialLessonModal"
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "page-route": "/user/userExperienceList",
      "default-task-type": "SALES_FOLLOWUP"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.search,
      "on-close": _vm.onAiClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77889124","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserExperienceList.vue
// module id = 1892
// module chunks = 8